import { Controller } from "@hotwired/stimulus"

// Light/dark theme toggle.
//
// The no-flash script in src/_partials/_head.erb sets <html data-theme> from
// localStorage (or the OS preference) before first paint. This controller is
// attached to the contrast-icon button in the navbar: clicking it flips the
// theme on the document and persists the choice. The <html> element survives
// Turbo navigations, so the chosen theme persists across page visits.
export default class extends Controller {
  static values = { storageKey: { type: String, default: "theme" } }

  connect() {
    this.#syncPressed(this.#currentTheme())
  }

  toggle() {
    const next = this.#currentTheme() === "dark" ? "light" : "dark"
    document.documentElement.setAttribute("data-theme", next)
    localStorage.setItem(this.storageKeyValue, next)
    this.#syncPressed(next)
  }

  #syncPressed(theme) {
    // aria-pressed=true means "dark is on"; keeps the button accessible.
    this.element.setAttribute("aria-pressed", theme === "dark" ? "true" : "false")
  }

  #currentTheme() {
    return document.documentElement.getAttribute("data-theme") === "dark"
      ? "dark"
      : "light"
  }
}
